/**
 * /admin/recovery-requests — Tier 1-3 recovery queue (route shell).
 * Screen impl in `./recovery-requests-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/recovery-requests')({
  component: lazyRouteComponent(
    () => import('./recovery-requests-screen'),
    'AdminRecoveryRequests',
  ),
});
